<template>
    <div>

        <div class="panel panel-info">
            <div class="panel-heading">
                <i class="fa fa-table" aria-hidden="true"></i> ATENDIMENTOS DO CONTRATO
            </div>
            <div class="panel-body">

                <table id="mytable" class="table table-bordred table-striped">

                    <thead>
                        <tr>
                            <th style="text-align: center;width: 100px">PROTOCOLO</th>
                            <th>MOTIVO</th>
                            <th style="text-align: center;width: 120px">DATA</th>
                            <th style="text-align: center;width: 120px">USUÁRIO</th>
                            <th style="text-align: center;width: 80px">AÇÕES</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="r in contratos" v-bind:key="r._id">
                            <td style="text-align: center; vertical-align: middle">{{ r.protocolo.final }}</td>
                            <td style="vertical-align: middle">{{ r.motivo.nome }}</td>
                            <td style="text-align: center; vertical-align: middle">{{ r.created_at | date("DD-MM-YYYY HH:mm:ss") }}</td>
                            <td style="text-align: center; vertical-align: middle">{{ r.usuario.nome }}</td>
                            <td>
                                <button type="button" @click="abrir(r._id)" class="btn btn-xs btn-block btn-primary">
                                    <i class="fa fa-external-link-alt" /> ABRIR
                                </button>
                            </td>
                        </tr>
                    </tbody>

                </table>

            </div>

        </div>
    </div>
</template>
<script>
import { Atendimento } from "../../class/index";
import { date } from "../../filters";

export default {
    filters: {
        date
    },
    props: {
        id: {
            default: null
        }
    },
    data() {
        return {
            contratos: [],
            user: null
        };
    },
    beforeMount() {
        this.user = this.$store.state.user;
        this.loadComandos();
    },
    methods: {
        async loadComandos() {
            this.contratos = await Atendimento.byContrato(this.id);
        },
        abrir(id) {
            this.$emit("open", id);
        }
    }
};
</script>
